export const defaultSettings = {
  infinite: true,
  cssEase: 'linear',
  slidesToScroll: 1,
  swipe: true,
  swipeToSlide: true,
  autoplaySpeed: 0,
  pauseOnHover: true,
};
